import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { EID } from '@/lib/element-ids.registry'
import { useListingAuditVersions } from '@/hooks/useListingBuilder'

export function AuditVersionSelector({ jobId }: { jobId: string }) {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const { jobId: activeJobId } = useParams<{ jobId: string }>()
  const { data, isLoading } = useListingAuditVersions(jobId)

  const versions = data?.versions ?? []
  if (versions.length <= 1) return null

  const fmtDate = (iso: string) =>
    new Date(iso).toLocaleDateString(i18n.language, { day: '2-digit', month: '2-digit', year: 'numeric' })

  const optionLabel = (v: (typeof versions)[number]) => {
    const isCurrent = v.id === activeJobId
    const base = `v${v.version_number} · ${v.status} · ${fmtDate(v.created_at)}`
    return isCurrent ? `${base} (${t('listingBuilder.detail.versions.current')})` : base
  }

  return (
    <label className="inline-flex items-center gap-2 text-sm text-neutral-500">
      {t('listingBuilder.detail.versions.label')}
      <select
        id={EID['listing-builder-audit-version-select']}
        value={activeJobId}
        disabled={isLoading}
        onChange={(e) => navigate(`/v2/tools/listing-builder/${e.target.value}`)}
        className="rounded-md border border-neutral-200 bg-white px-2 py-1 text-sm text-neutral-700 dark:border-neutral-700 dark:bg-neutral-900 dark:text-neutral-200"
      >
        {versions.map((v) => (
          <option key={v.id} value={v.id}>
            {optionLabel(v)}
          </option>
        ))}
      </select>
    </label>
  )
}
